export default "__VITE_ASSET__C59uNCH4__"